/* eslint-disable import/no-extraneous-dependencies */
import React, { memo } from "react";
import Media from "@qlik/qlik/src/components/Media";
import Cta from "@qlik/qlik/src/components/Cta";
import { handleKeyboardEventBehavior } from "@qlik/qlik/src/lib/util/helpers";

const CustomerSliderCard = memo(({ card, className = "", onClick, onMouseEnter, onMouseLeave, type = "mobile" }) => {
    // Check if the card type is mobile
    const isMobile = type === "mobile";

    // Handler for mouse enter event
    const onMouseEnterHandler = () => {
        if (onMouseEnter) onMouseEnter();
    };

    // Handler for mouse leave event
    const onMouseLeaveHandler = () => {
        if (onMouseLeave) onMouseLeave();
    };

    // Get the logo and image from the card media
    const logo = card?.mediaIcon;
    const image = card.media?.[0];
    const backgroundImage = "'" + card?.media?.[0]?.desktopMedia?.[0]?.secure_url + "'";
    return (
        // Card container
        <div
            style={{ boxShadow: "0 1.48571px 7.42857px 0 rgba(0, 0, 0, 0.08)" }}
            className={`bg-white h-full relative overflow-hidden group rounded min-h-[413px] md:min-h-[648px] lg:h-135 ${className} ${
                isMobile
                    ? ""
                    : "lg:min-h-[540px] lg:w-70 xl:w-87.5 transition-all duration-700 ease-out lg:hover:w-125 xl:hover:w-157.5 lg:hover:h-135"
            }`}
            onClick={onClick}
            onMouseEnter={onMouseEnterHandler}
            onMouseLeave={onMouseLeaveHandler}
            role="button"
            tabIndex={-1}
            onKeyDown={(e) => {
                handleKeyboardEventBehavior(e, onClick);
            }}
        >
            {/* Card content */}
            <div
                className={`p-7.5 xl:p-10 relative z-1 ${
                    isMobile
                        ? ""
                        : "group-hover:flex flex-col group-hover:h-135 lg:group-hover:w-125 xl:group-hover:w-157.5 lg:hover:h-135"
                }`}
            >
                {/* Card title */}
                <p
                    className={`text-blue lg:text-gray text-md font-semibold leading-tight tracking-tight3 h-[130px] lg:h-40 line-clamp-6 mb-5 sm:text-xl sm:tracking-normal ${
                        isMobile
                            ? ""
                            : `whitespace-pre-wrap lg:w-55 xl:w-67.5 lg:group-hover:w-full lg:group-hover:mb-9.5 transition-colors duration-700 ease-out group-hover:text-white group-hover:text-5xl lg:group-hover:tracking-tight1-l lg:group-hover:h-[154px] ${
                                  card.cta ? "lg:group-hover:line-clamp-4" : "lg:group-hover:line-clamp-none"
                              }`
                    }`}
                >
                    {card.title}
                </p>
                {/* Card description and links for non-mobile devices */}
                {!isMobile && (
                    <div className="transition-opacity duration-700 mb-0 opacity-0 h-0 overflow-hidden group-hover:min-h-[186px] gap-3 flex flex-col justify-between group-hover:h-auto group-hover:mb-3  group-hover:opacity-100">
                        <div className="flex flex-wrap items-center">
                            {card.cta?.map((button) => (
                                <div key={button.id}>
                                    <Cta key={button.id} data={button} />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {/* Card logo */}
                {logo && (
                    <Media
                        media={logo}
                        className={`transition-all duration-700 object-scale-down h-10 w-full object-left-bottom lg:h-[41px] mt-4.5 pointer-events-none ${
                            isMobile
                                ? ""
                                : "group-hover:h-[69px] max-w-[208px] group-hover:mt-auto group-hover:brightness-0 group-hover:invert group-hover:object-contain"
                        }`}
                    />
                )}
            </div>
            {/* Card image */}
            <div className="h-[163px] md:h-[398px] lg:h-55">
                {image && (
                    <Media
                        media={image}
                        className={`w-full rounded-b object-cover h-[163px] md:h-[398px] lg:h-55 absolute bottom-0 ${
                            isMobile ? "" : "group-hover:hidden"
                        }`}
                    />
                )}
                {/* Default behavior white logo */}
                <div className="h-full flex justify-center items-center">
                    {image && (
                        <Media
                            media={logo}
                            className={`object-cover relative m-auto invert brightness-0 w-[136px] ${
                                isMobile ? "" : "group-hover:hidden"
                            }`}
                        />
                    )}
                </div>
            </div>

            {/* Card background image for non-mobile devices */}
            {!isMobile && (
                <div
                    style={{ "--image-url": `url(${backgroundImage})` }}
                    className="hidden rounded blend-background group-hover:block absolute inset-0 lg:h-135"
                />
            )}
        </div>
    );
});

export default CustomerSliderCard;
